import * as React from 'react'
import { SVGProps } from 'react'
const SvgStarBg = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 519.966 519.966" {...props}>
    <path d="m514.584 325.123-65.146 25.699 20.32 66.939-69.328-1.195-6.574 69.328-63.95-27.492-32.869 61.561-48.411-50.203-53.789 44.822-25.699-65.145-66.938 20.919 1.195-69.926-69.328-6.574 27.492-63.949L0 297.635l50.202-49.009-44.824-53.788 65.145-25.699-20.32-66.34 69.328 1.195 6.574-69.926 63.949 28.09L222.925.002l48.413 50.201 53.789-44.227 25.697 64.547 66.938-20.32-1.195 69.926 69.328 6.574-27.492 63.949 61.563 32.273-50.203 48.411z" />
  </svg>
)
export default SvgStarBg
